import React from "react";
import PropTypes from "prop-types";
import styles from "./CategoryToggle.module.css";

export function CategoryToggle({ options, active, onChange }) {
  return (
    <div className={styles.toggleRow}>
      {options.map((option) => (
        <button
          key={option}
          className={`${styles.toggleButton}${
            active === option ? ` ${styles.active}` : ""
          }`}
          onClick={() => onChange(option)}
          type="button"
        >
          {option}
        </button>
      ))}
    </div>
  );
}

CategoryToggle.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  active: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
